import React, {useState} from "react";
import { IonGrid, IonRow, IonCol } from '@ionic/react';
import { AutoComplete,  } from 'antd';
import { useRecoilState, } from "recoil";
import { optmizedBooking } from "../../../store/atoms/bookingDetailAtoms"
import { handleWayPointAddition } from "../handler"

const maximizedAddressComponent = (title , index, setSelectedInputAddress) => {
    return (
        <div className='deactive'>
           <IonGrid>
              <IonRow>
                <IonCol>
                  <h4>{title} - L</h4>
                </IonCol>
              </IonRow>
              <IonRow>
                <IonCol size="6">
                   <h6>Search Address</h6>
                    <AutoComplete style={{height: "50px", width: "350px" }}>
                    </AutoComplete>
                </IonCol>
                   <IonCol><h6>Floor</h6><input type="text" /></IonCol>
                   <IonCol><h6>Unit Number</h6><input type="text" /></IonCol>
               </IonRow>
               <IonRow>
                  
                   <IonCol><h6>Contact Name*</h6><input type="text" /></IonCol>
                   <IonCol><h6>Contact Number*</h6><input type="text"  /></IonCol>
               </IonRow>
           </IonGrid>
       </div>
    )
}

const minimizedAddressComponent = (title, index, setSelectedInputAddress) => {
    return (
        <div className='active'>
            <h4 className='selected-address' >{title}</h4>
            <p> Unit :   |   Contact :  </p> 
            <button className='outline'><img alt="img edit" src="img/edit.svg" /></button> 
            <button className='outline delete'><img alt="trash" src="img/trash.svg" /></button> 
       </div>
    )
}  

const button = (waypointLength, title,optmizedBookingState, setOptimizedBookingState, setSelectedInputAddress, setWaypointLength) => {
    if(waypointLength < 8) {
        return (
            <div className='active' onClick={()=>{handleWayPointAddition(optmizedBookingState,setOptimizedBookingState, setSelectedInputAddress, setWaypointLength)}}>
                <h4 className='selected-address' > {title}</h4>
                <p>  </p> 
                <button className='outline'><img alt="img edit" src="img/edit.svg" /></button> 
                <button className='outline delete'><img alt="trash" src="img/trash.svg" /></button> 
           </div>
        )
    }
    
} 



const InputAddressComponent = () => {
    const [optmizedBookingState, setOptimizedBookingState] = useRecoilState(optmizedBooking);
    const [selectedInputAddress, setSelectedInputAddress] = useState(0)
    const [waypointLength, setWaypointLength] = useState(optmizedBookingState.waypoints.length)
    
    const title = {
        '0' : 'Enter Pick-Up Address',
        '1' : 'Enter Drop-Off Address',
        '2' : '1 +Add Stop',
        '3' : '2 +Add Stop',
        '4' : '3 +Add Stop',
        '5' : '4 +Add Stop',
        '6' : '5 +Add Stop'
    }

    return (
        <>
            {  optmizedBookingState.waypoints.map((e, i)=>{
                if(i === selectedInputAddress) {
                    return (
                        <>
                            {maximizedAddressComponent(title[`${i}`],i, setSelectedInputAddress )}
                        </>
                    )
                } else {
                    return (
                        <>
                            {minimizedAddressComponent(title[`${i}`], i, setSelectedInputAddress)}
                        </>
                    )
                }
                }) 
            }
            {
                button(waypointLength, title[`${waypointLength}`],optmizedBookingState, setOptimizedBookingState, setSelectedInputAddress, setWaypointLength)
            }
        </>
    )
}

export default InputAddressComponent; 